<template>
  <div class="jc-page-container">
    <div class="jc-page-header">
      <el-page-header show-back-icon @back="back" class="relative">
        <template slot="title">
          <span class="first-level-title">下级渠道商列表</span>

          /
          <span>{{ distributorId === '' ? '新增渠道商' : '修改渠道商' }}</span>
        </template>
      </el-page-header>
    </div>

    <div class="jc-page-content">
      <div class="jc-page-card">
        <el-alert type="warning" :closable="false" class="mb-16px">
          <p slot="title">
            您可以通过该页面添加您的二级渠道商，若需要关联客户，需让客户访问<router-link
              :to="{ path: '/partner/info' }"
            >
              我的信息
            </router-link>

            页中的邀请链接进行关联。
          </p>
        </el-alert>

        <el-form
          label-width="130px"
          :model="form"
          :rules="rules"
          ref="form"
          label-position="left"
        >
          <sk-section title="基本信息">
            <div class="jc-form-tiny-width">
              <el-form-item label="渠道商名称：" prop="distributorName">
                <el-input
                  v-model.trim="form.distributorName"
                  class="second-distributor-loading"
                  placeholder="请填写营业执照上的公司名称"
                ></el-input>

                <!-- <p slot="hint">请填写营业执照上的公司名称</p> -->
              </el-form-item>

              <el-form-item label="PIN：" prop="pin">
                <template v-if="distributorId === ''">
                  <el-input
                    v-model.trim="form.pin"
                    class="user-loading second-distributor-loading"
                    placeholder="请填写该渠道商在京东云的PIN"
                  ></el-input>
                </template>

                <template v-else>
                  <p style="margin-top: 4px" slot="hint">{{ form.pin }}</p>
                </template>
              </el-form-item>
            </div>

            <p
              v-if="distributorId === ''"
              style="left: 130px;display: inline-block;position: relative;top: -5px;color: #ccc;}"
            >
              PIN可由下级渠道商在账户管理-基本资料中查看，网址：https://uc.jdcloud.com/account/basic-info；
            </p>
          </sk-section>

          <sk-section title="工商信息">
            <div class="jc-form-tiny-width">
              <el-form-item label="营业执照号：" prop="businessLicense">
                <el-input
                  v-model.trim="form.businessLicense"
                  class="second-distributor-loading"
                  placeholder="请填写营业执照号码或统一社会信用代码"
                ></el-input>

                <!-- <p slot="hint">请填写营业执照号码或统一社会信用代码</p> -->
              </el-form-item>

              <el-form-item label="法定代表人：" prop="legalRepresentative">
                <el-input v-model.trim="form.legalRepresentative"></el-input>
              </el-form-item>

              <el-form-item
                label="营业执照："
                prop="businessLicensePic"
                required
              >
                <sk-upload
                  v-model="form.businessLicensePic"
                  @success="uploadSuccess"
                ></sk-upload>

                <p slot="hint">图片尺寸建议大小：800*600px</p>
              </el-form-item>
            </div>
          </sk-section>

          <sk-section title="公司信息">
            <div class="jc-form-tiny-width">
              <el-form-item label="主营业务描述：" prop="businessDesc">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 10 }"
                  v-model.trim="form.businessDesc"
                  placeholder="公司业务主要覆盖XXX行业、XXX等区域市场及XXX等重点客户。主营业务为XXX；团队规模XXX人，其中销售人员XXX人，技术支持人员XXX人。最近两年的营业收入分别为：XXX，AAA。"
                ></el-input>

                <!-- <p slot="hint">公司业务主要覆盖XXX行业、XXX等区域市场及XXX等重点客户。主营业务为XXX；团队规模XXX人，其中销售人员XXX人，技术支持人员XXX人。最近两年的营业收入分别为：XXX，AAA。</p> -->
              </el-form-item>

              <el-form-item label="办公地址：" prop="workAddress">
                <el-input
                  v-model.trim="form.workAddress"
                  placeholder="请输入公司详细地址"
                ></el-input>
              </el-form-item>

              <el-form-item label="联系人姓名：" prop="contracter">
                <el-input v-model.trim="form.contracter"></el-input>
              </el-form-item>

              <el-form-item label="联系电话：" prop="tel">
                <el-input v-model.trim="form.tel"></el-input>
              </el-form-item>

              <el-form-item label="邮箱：" prop="email">
                <el-input v-model.trim="form.email"></el-input>
              </el-form-item>
            </div>
          </sk-section>

          <sk-section title="银行信息" v-if="!showBank">
            <div class="jc-form-tiny-width">
              <el-form-item label="银行开户名：" prop="bankCompanyName">
                <el-input
                  v-model.trim="form.bankCompanyName"
                  class="second-distributor-loading"
                ></el-input>
              </el-form-item>

              <el-form-item label="银行账号：" prop="bankCardNo">
                <el-input
                  v-model.trim="form.bankCardNo"
                  class="user-loading second-distributor-loading"
                ></el-input>
              </el-form-item>

              <el-form-item label="开户行支行名称：" prop="bankBranchName">
                <el-input
                  v-model.trim="form.bankBranchName"
                  class="second-distributor-loading"
                ></el-input>
              </el-form-item>

              <el-form-item label="开户行联行号：" prop="bankBranchNo">
                <el-input
                  v-model.trim="form.bankBranchNo"
                  class="user-loading second-distributor-loading"
                ></el-input>
              </el-form-item>
            </div>
          </sk-section>

          <sk-section title="附加信息" v-if="showErp">
            <div class="jc-form-tiny-width">
              <el-form-item label="所属京东云销售：" prop="erp">
                <el-input v-model.trim="form.erp" class="verifyErp"></el-input>
              </el-form-item>

              <p
                style="left: 130px;display: inline-block;position: relative;top: -5px;color: #ccc;}"
              >
                该下级渠道商所属的京东云销售，默认为您的销售，您可以按业务进行修改
              </p>
            </div>
          </sk-section>

          <el-form-item style="margin-left: 12px">
            <el-button @click="goback">取消</el-button>

            <el-button type="primary" @click="submit">立即提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { SERVICE_PROVIDER_CREATE_RULE } from '@/views/service/rules'
import routerMixins from '@/mixins/router-mixins.js'
import { isNull } from '@/utils'
import {
  addSecondInfo,
  modifySecondInfo,
  getSecondInfo,
  displayExtraInfo,
} from '@/api/distributor-api.js'
export default {
  props: {},
  components: {},
  mixins: [routerMixins],
  data() {
    return {
      form: {
        distributorName: '',
        pin: '',
        businessLicense: '',
        legalRepresentative: '',
        businessLicensePic: {
          imgUrl: '',
          businessLicensePic: '',
        },
        businessDesc: '',
        workAddress: '',
        contracter: '',
        tel: '',
        email: '',
        bankCompanyName: '',
        bankCardNo: '',
        bankBranchName: '',
        bankBranchNo: '',
        erp: '',
      },
      showBank: 1,
      rules: SERVICE_PROVIDER_CREATE_RULE.call(this),
      defaultForm: {},
      distributorId: this.$route.params.id || '',
      //'214f8a3b62d14a9ebc7ccf636c46e678'
      showErp: false,
    }
  },
  created() {
    if (this.distributorId !== '') {
      this.getDetail()
    } else {
      this.displayExtraInfo()
    }
    let { hasSub, hasSubReturn, subReturnMode } = this.$store.state.distributor
    this.showBank = hasSub || hasSubReturn
    if (isNull(this.showBank) || subReturnMode !== 1) {
      this.showBank = 1
    }
  },
  watch: {
    showBank(val) {
      if (val === 0) {
        this.rules.bankCompanyName[0].required = true
        this.rules.bankCardNo[0].required = true
        this.rules.bankBranchName[0].required = true
        this.rules.bankBranchNo[0].required = true
      } else {
        this.rules.bankCompanyName[0].required = false
        this.rules.bankCardNo[0].required = false
        this.rules.bankBranchName[0].required = false
        this.rules.bankBranchNo[0].required = false
      }
    },
  },
  computed: {},
  filters: {},
  methods: {
    async getDetail() {
      let { result } = await getSecondInfo({
        distributorId: this.distributorId,
      })
      if (result && result.distributorResult) {
        this.form = Object.assign(this.form, result.distributorResult)
        this.form.businessLicensePic = {
          imgUrl: this.form.businessLicensePicUri,
          businessLicensePic: this.form.businessLicensePic,
        }
        this.defaultForm = Object.assign(this.defaultForm, this.form)
      }
    },
    goback() {
      this.$router.push({
        name: 'serviceProviderList',
      })
    },
    submit() {
      this.$refs['form'].validate(async (value) => {
        if (value) {
          //新建
          try {
            if (this.distributorId === '') {
              await addSecondInfo({
                ...this.form,
                businessLicensePic:
                  this.form.businessLicensePic.businessLicensePic,
              })
            } else {
              //修改
              await modifySecondInfo({
                ...this.form,
                businessLicensePic:
                  this.form.businessLicensePic.businessLicensePic,
              })
            }
            this.$router.push({
              name: 'status',
              params: {
                status: 'submit-success',
              },
              query: {
                hideSideMenu: 1,
              },
            })
          } catch (err) {
            console.log(err)
          }
        }
      })
    },
    uploadSuccess() {
      this.$refs['form'].validateField('businessLicensePic')
    },
    back() {
      this.$router.back()
    },
    async displayExtraInfo() {
      const { result = {} } = await displayExtraInfo()
      this.showErp = result.result && result.result.isShow
      this.form.erp = result.result && result.result.erp
    },
  },
}
</script>

<style>
.jc-page-header .jc-button--text {
  padding: 0;
  margin-top: 20px;
  vertical-align: top;
}
.jc-page-header .jc-status {
  margin-right: 10px;
}
.bankName .jc-form-item__label {
  margin-left: -10px !important;
}
.bankName .jc-form-item__content {
  margin-left: 100px !important;
}
</style>
